import React, { useEffect, useState } from 'react';
import './style.scss';
import '../style.scss';

import { Input, Modal } from 'antd';
import { BANKS } from '../constant/banks';
import { IOS_APP_DEEP_LINKS } from '../constant/ios-app-deeplinks';
import { ANDROID_APP_DEEP_LINKS } from '../constant/android-app-deeplinks';
import PaymentGuide from '../PaymentGuide/PaymentGuide';
import { DEVICE } from '../constant/contanst';
import { cjmEventItemSelected } from 'utils/providers/cjmHelper';

const ChooseBankingApp = ({ setStep, device, isModal, setIsModal, onClick, listBanks }) => {
  const [searchText, setSearchText] = useState("");
  const [bigFourBanks, setBigFourBanks] = useState([]);
  const [allBanks, setAllBanks] = useState([]);
  const [isModalPaymentGuide, setIsModalPaymentGuide] = useState(false);
  const [bankCode, setBankCode] = useState(false);
  const [isShowListBanks, setIsShowListBanks] = useState(false);

  useEffect(() => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    let listAllBanks = [];
    
    if(listBanks && listBanks.length > 0) {
      listAllBanks = listBanks;
      setIsShowListBanks(true);
    } else if (userAgent.includes("iphone") || userAgent.includes("ipad")) {
      listAllBanks = BANKS.filter((bank) =>
        IOS_APP_DEEP_LINKS.some((item) => bank.bankCode.toLowerCase() === item.appId.toLowerCase())
      );
    } else if (userAgent.includes("android")) {
      listAllBanks = BANKS.filter((bank) =>
        ANDROID_APP_DEEP_LINKS.some((item) => bank.bankCode.toLowerCase() === item.appId.toLowerCase())
      );
    } else {
      console.log("This feature is only supported on iOS and Android devices.");
      listAllBanks = BANKS;
    }
    setAllBanks(listAllBanks);
    setBigFourBanks(listAllBanks.slice(0, 4));
  }, [listBanks]);

  const submitSearch = (e) => {
    const value = e.target.value;
    setSearchText(value);
    const searchBanks = isShowListBanks ? listBanks : BANKS;
    if (!value.trim()) {
      setAllBanks(searchBanks);
      return;
    }
    const filteredBanks = searchBanks.filter((bank) =>
      bank.bankShortName.toLowerCase().includes(value.toLowerCase())
    );
    setAllBanks(filteredBanks);
  };

  const handleOpenPaymentGuide = (bankCode, bankName) => {
    cjmEventItemSelected("myvnpt_web", "roaming_package_QR", 'bank_list', bankName);
    const checkDisplayModal = localStorage.getItem('checkDisplayModal');
    setIsModal(false);
    
    // true ẩn guide
    if (checkDisplayModal != 'true') {
      setIsModalPaymentGuide(true);
      setBankCode(bankCode)
    } else {
      openMobileApp(bankCode);
    }
  }

  const openMobileApp = (bankCode) => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    let deepLink = "";

    if (isShowListBanks) {
      const bankCurrent = listBanks.find(bank => bank.bankCode.toLowerCase() === bankCode.toLowerCase());
      if (userAgent.includes("iphone") || userAgent.includes("ipad")) {
        if (bankCurrent) deepLink = bankCurrent.ios.deeplink;
      } else if (userAgent.includes("android")) {
        if (bankCurrent) deepLink = bankCurrent.android.deeplink;
      } else {
        console.log("This feature is only supported on iOS and Android devices.");
        return;
      }
    } else {
      if (userAgent.includes("iphone") || userAgent.includes("ipad")) {
        const foundApp = IOS_APP_DEEP_LINKS.find(
          (item) => item.appId.toLowerCase() === bankCode.toLowerCase()
        );
        if (foundApp) deepLink = foundApp.deeplink;
      } else if (userAgent.includes("android")) {
        const foundApp = ANDROID_APP_DEEP_LINKS.find(
          (item) => item.appId.toLowerCase() === bankCode.toLowerCase()
        );
        if (foundApp) deepLink = foundApp.deeplink;
      } else {
        console.log("This feature is only supported on iOS and Android devices.");
        return;
      }
    }

    if (deepLink) {
      window.location.href = deepLink;
      setTimeout(() => {
        setStep(2);
      }, 1000);
    }
  };

  return (
    <>
      <Modal
        className="qr-code__modal-custom"
        title={null}
        footer={null}
        closable={null}
        open={isModal}
      >
        <div className="qr-code-modal-choose-bank">
          <div className="modal-choose-bank-header">
            <div className="modal-choose-bank-title">{device === DEVICE.ANDROID ? "Mã QR đã được tải xuống" : "Mở ứng dụng ngân hàng của bạn"}</div>
            <div className="modal-choose-bank-subtitle">{device === DEVICE.ANDROID ? "Mở ứng dụng ngân hàng của bạn" : "Và quét mã QR đã được tải xuống"}</div>
          </div>
          <div className="modal-choose-bank-txt">Đề xuất</div>
          <div className="modal-choose-bank-propose modal-choose-bank-list">
            {bigFourBanks.map((item) => (
              <div
                key={item?.bankCode}
                className="modal-choose-bank-item"
                onClick={() => handleOpenPaymentGuide(item?.bankCode, item?.bankName)}
              >
                <img
                  src={item?.logo}
                  alt={item?.bankName}
                />
              </div>
            ))}
          </div>
          <div className="modal-choose-bank-txt">Tất cả ngân hàng</div>
          <Input
            className="qr-code__input-custom qr-code__input-choose-bank"
            placeholder="Tìm kiếm"
            value={searchText}
            onChange={submitSearch}
          />
          {allBanks.length > 0 ? (
            <div className="modal-choose-bank-list">
              {allBanks.map((item) => (
                <div 
                  key={item?.bankCode} 
                  className="modal-choose-bank-item"
                  onClick={() => {
                    handleOpenPaymentGuide(item?.bankCode, item?.bankName)
                  }}
                >
                  <img
                    src={item?.logo}
                    alt={item?.bankName}
                  />
                </div>
              ))}
            </div>
          ) : (
            <div className="modal-choose-bank-not-found">
              Không tìm thấy ngân hàng
            </div>
          )}
        </div>
      </Modal>
      <PaymentGuide isModal={isModalPaymentGuide} openMobileApp={openMobileApp} bankCode={bankCode} onClick={() => setIsModalPaymentGuide(false)} />
    </>
  );
};

export default React.memo(ChooseBankingApp);
